export function OptinNotOptinBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
    let joint = services.joint;
    return joint.shapes.html.AbstractBoxElementView.extend({

        isElementEditable: true,
        editElementModalController: 'editOptinListController',
        editElementModalTemplate: require('./editOptinList.modal.html'),

        angularTemplate: `
            <div layout="column">
                <span> {{elementData.label}} </span>
            </div>
            `,   
    });
  
}